/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserResponseDto = {
    /**
     * Идентификатор пользователя
     */
    id: number;
    /**
     * ID пользователя в Keycloak
     */
    keycloakUserId: string;
    /**
     * Фамилия
     */
    lastname: string;
    /**
     * Имя
     */
    firstname: string;
    /**
     * Отчество
     */
    middleName?: string;
    /**
     * Компания
     */
    company: string;
    /**
     * ИНН компании
     */
    innCompany?: string;
    /**
     * Email пользователя
     */
    email: string;
    /**
     * Статус пользователя
     */
    status: UserResponseDto.status;
    /**
     * Комментарий администратора
     */
    comment?: string;
    /**
     * Мобильный телефон
     */
    mobilePhone?: string;
};

export namespace UserResponseDto {

    /**
     * Статус пользователя
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        SUSPENDED = 'SUSPENDED',
        PENDING = 'PENDING',
    }


}

